//# sourceMappingURL=my-date-range-model.interface.js.map


//////////////////
// WEBPACK FOOTER
// ./~/mydaterangepicker/dist/interfaces/my-date-range-model.interface.js
// module id = 876
// module chunks = 9